import { attach } from 'effector';

import { getTodoListFx } from 'shared/api';

import { getParamsForCurrentWeek, getParamsForPreviousWeeks } from '../lib/getParams';

export const getCurrentTodosFx = attach({
  effect: getTodoListFx,
  mapParams: getParamsForCurrentWeek,
});

export const getPreviousTodosFx = attach({
  effect: getTodoListFx,
  mapParams: getParamsForPreviousWeeks,
});
